import { getImageSrc } from './local-util'
import { DYNAMIC_MEDIA_PROD, DYNAMIC_MEDIA_STAGING, isLocalHost, isProd, isStage, ORIGIN } from '../constants'

export const getDynamicMedia = (imageSrc: string, component: DynamicMediaComponents, imageName?: string) => {
  const isSVG = imageSrc?.includes('.svg')
  if (!isSVG && !isLocalHost()) {
    if (imageName && isProd.includes(ORIGIN)) {
      return DYNAMIC_MEDIA_PROD + imageName + component
    } else if (imageName && isStage.includes(ORIGIN)) {
      return DYNAMIC_MEDIA_STAGING + imageName + component
    }
  } else {
    return getImageSrc(imageSrc, component)
  }
}

export const getDynamicMediaFromSrc = (imageSrc: string, component: DynamicMediaComponents) => {
  // get last section after /
  const fileName = splitLastOccurrence(imageSrc, '/')
  // remove the extension
  const fileNameArr = (typeof fileName === 'string' && fileName.split('.')) || []
  return getDynamicMedia(imageSrc, component, fileNameArr[0])
}

function splitLastOccurrence(str?: string, substring?: string) {
  if (str && substring) {
    const lastIndex = str.lastIndexOf(substring)
    const lastOccurrence = str.slice(lastIndex + 1)
    return lastOccurrence
  }
  return ''
}

export enum DynamicMediaComponents {
  CAROUSEL_ARTICLE = '?$carousel-article$',
  CAROUSEL_IMAGERY = '?$carousel-imagery$',
  CAROUSEL_PRODUCT = '?$carousel-product$',
  CAROUSEL_PSU = '?$carousel-psu$',
  TEASER = '?$teaser$',
  TEASER_IMAGE_TWO_UP = '?$teaser-image-two-up$',
  TEASER_IMAGE_THREE_UP = '?$teaser-image-three-up$',
  TEASER_IMAGE_FOUR_UP = '?$teaser-image-four-up$',
  PRODUCT_TEASER_FEATURED = '?$product-teaser-featured$',
  COMMERCE_TEASER = '?$commerce-teaser$',
  MODAL_BASIC = '?$modal-basic$',
  BANNER = '',
  TRANSPARENT_BG = '?$transparent-bg$',
  PSU_TEASER = '?$psu-teaser$'
}
